import { Fragment } from "react";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetFontRootColorClass } from "vagaro-website-rendering/src/components/Definitions/ComponentClassHelper";
import  {  AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { SiteData } from "../Data/SiteData";
import { UpdateStyleFunction } from "../Stylebuilder";

export default class BlogList extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.blogList;
        this.displayName = "Blog List";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = ["blogListLayout","bloglistshowauthor","bloglistshowcats","bloglistshowtags","bloglistshowdate","bloglistshowreadtime","panelRadius","bloglistimgradius","blog-filter"];
        this.colorFields =["color","panelColor"]
        this.editList = [...this.colorFields,...this.primaryEditAttributes, ...CreateAttributeList(true, true, false, true, false,false,false)];
    

        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="1em" fill="currentColor"><path d="M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"/></svg>
    
        this.cssDefinitions = [
            new NodeCSSClassDefinition(".blog-card",
                [
                    { key: "panelColor", cssProperty: "background", default: "" },
                    { key: "panelRadius", cssProperty: "border-radius", default: "" },
                    { key: "panelBorder", cssProperty: "border-color", default: "" }

                ]),
            new NodeCSSClassDefinition(".read-time",
                [
                    { key: "bloglistshowreadtime", cssProperty: "display", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-tag",
                [
                    { key: "bloglistshowtags", cssProperty: "display", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-cat",
                [
                    { key: "bloglistshowcats", cssProperty: "display", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-list-author",
                [
                    { key: "bloglistshowauthor", cssProperty: "display", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-list-publish-date",
                [
                    { key: "bloglistshowdate", cssProperty: "display", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-post-image",
                [
                    { key: "bloglistimgradius", cssProperty: "border-radius", default: "" },


                ]),
            new NodeCSSClassDefinition(".blog-card:hover",
                [
                    { key: "x", cssProperty: "opacity", default: ".85" },
                ]),
        ]
    
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("blogListLayout", "Layout","", AttributeInputType.SelectField, [
                { label: "List", value: "1" },
                { label: "Cards", value: "cards" },
                { label: "Large", value: "large" },
                {label:"Condensed",value:"condensed"}
            ]),
            new AttributeDefinition("bloglistshowreadtime", "Read Time","", AttributeInputType.ButtonField, [
                { label: "Show", value: "" },
                { label: "Hide", value: "none" },
         
            ]),
            new AttributeDefinition("bloglistshowtags", "Tags","", AttributeInputType.ButtonField, [
                { label: "Show", value: "" },
                { label: "Hide", value: "none" },
         
            ]),
            new AttributeDefinition("bloglistshowcats", "Categories","", AttributeInputType.ButtonField, [
                { label: "Show", value: "" },
                { label: "Hide", value: "none" },
         
            ]),
            new AttributeDefinition("bloglistshowauthor", "Author","", AttributeInputType.ButtonField, [
                { label: "Show", value: "" },
                { label: "Hide", value: "none" },
         
            ]),
            new AttributeDefinition("bloglistshowdate", "Date","", AttributeInputType.ButtonField, [
                { label: "Show", value: "" },
                { label: "Hide", value: "none" },
         
            ]),
            new AttributeDefinition("bloglistimgradius", "Image Radius","", AttributeInputType.MeasurementField, [
                { label: "Auto", value: "" },
                { label: "S", value: "0px" },
                { label: "M", value: "8px" },
                { label: "L", value: "24px" },
         
            ],{min:0,max:200,step:1,unit:"px"}),
            new AttributeDefinition("blog-filter", "Filters","", AttributeInputType.BlogFilter),
        ]
    }

    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData, }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean; siteData: SiteData; }): JSX.Element {
        const content = super.RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData });
        if (!layoutNode)
            return content;

        return (
            <>
              <div style={{borderBottom:"1px solid var(--panel-border)",padding:"16px 0"}}>
            <div className="wb-input-row gray-hover" >
              
                <button
                onClick={() => {
                   
                        (window as any).OpenToBlogSettings();
                   
                }}
                >Manage Posts</button></div></div>
                {content}

            </>
        )
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("max-100 w-full resizable-container scrollable "+GetFontRootColorClass(component), component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, "blogListLayout", "1");
        let filter = getNodeComponentAttributeValue(component, "blog-filter", "");
        if (!isEditor) { // decode the filter so that the placeholder can re encode it and not require rewriting placeholder component
            return <BusinessPlaceHolder inFilter={decodeURIComponent(filter)} node={component} dataKey={BusienssControlNames.blogList} layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                {isEditor&&
                    <style>
                        {super.GetComponentGlobalCSS(component,true)}
                    </style>
                }
                <div {...atts}>
                    <GenericBusinessControl filters={filter} key={component.id +filter}  layout={layout} dataKey={BusienssControlNames.blogList} node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }
}
